
document.addEventListener('DOMContentLoaded', function () {

    // add scroll class to body
    var body = document.querySelector('body');
    window.addEventListener('scroll', checkPosition);

    function checkPosition() {
        var windowY = window.scrollY;
        if (windowY < 100) {
            // Scrolling UP
            body.classList.remove('is-scrolled');
        } else {
            // Scrolling DOWN
            body.classList.add('is-scrolled');
        }
    }


}, false);